import { useEffect } from 'react';

import { observer } from 'mobx-react-lite';
import { soundService } from '../../../services/soundService';
import {
  getBrowserVisibilityProp,
  getIsDocumentHidden,
} from '../../../core/helpers/documentVisibility';

export const SoundWatcher = observer(() => {
  const handleVisibilityChange = () => {
    if (!getIsDocumentHidden()) {
      soundService.pauseSounds();
    } else {
      soundService.resumeSounds();
    }
  };

  useEffect(() => {
    const visibilityChange = getBrowserVisibilityProp();
    document.addEventListener(visibilityChange, handleVisibilityChange, false);
    return () => {
      document.removeEventListener(visibilityChange, handleVisibilityChange);
    };
    // eslint-disable-next-line
  }, []);

  return null;
});
